import * as assetsConstants from '../constants/assets';

export default function newAsset(state = { loading: false }, action) {
    switch (action.type) {
        case assetsConstants.NEW_ASSET_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case assetsConstants.NEW_ASSET_SUCCESS:
            return {
                ...state,
                error: undefined,
                loading: false,
            };
        case assetsConstants.NEW_ASSET_FAILURE:
            return {
                ...state,
                error: action.payload.error,
                loading: false,
            };
        case assetsConstants.NEW_ASSET_CLEAR_ERROR:
            return {
                ...state,
                error: undefined,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/newAssetReducer.js